import * as actions from "./template.actions";
import * as api from "./template.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY } from "./template.constants";
import * as hooks from "./template.hooks";
import * as promises from "./template.promises";
import reducer from "./template.reducer";
import { saga } from "./template.saga";
import * as selectors from "./template.selectors";
import * as utils from "./template.utils";
export * from "./template.types";
export var REDUCER_KEY_TEMPLATE = REDUCER_KEY;
export var templateModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: utils,
};
